import React from 'react';

import {
	useClassNames,
} from '@common';

import './Textarea.scss';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	onValueChange?: (newValue: string) => void
}

function Textarea(props: TextareaProps): JSX.Element {
	const {
		className,
		onValueChange,
		...textareaProps
	} = props;

	const classes = useClassNames(
		'textarea',
		className,
	);

	const onInputChange = (ev) => {
		if (onValueChange) {
			onValueChange(ev.target.value);
		}
	}

	return (
		<textarea
			className={classes}
			onChange={onInputChange}
			{...textareaProps}
		/>
	);
}

export {Textarea};